import { browser } from '$app/environment';

export default function getUrlHash() {
  if (browser) {
    return window.location.hash.slice(1);
  }
  return '';
}
